import { defineMessages } from '@jutro/locale';

export default defineMessages({
    cancelled: {
        id: 'ml.gateway.policySummaryDetails.Cancelled',
        defaultMessage: 'Cancelled'
    },
    expired: {
        id: 'ml.gateway.policySummaryDetails.Expired',
        defaultMessage: 'Expired'
    },
    active: {
        id: 'ml.gateway.policySummaryDetails.Active',
        defaultMessage: 'Active'
    },
    protectiveOrder: {
        id: 'ml.gateway.policySummaryDetails.Protective Order',
        defaultMessage: 'Protective Order'
    },
    policy: {
        id: 'ml.gateway.policySummaryDetails.Policy',
        defaultMessage: '{lob} Policy {state}'
    },
    policyNumber: {
        id: 'ml.gateway.policySummaryDetails.PolicyNumber',
        defaultMessage: '#{number}{leads}'
    },
    bundled: {
        id: 'ml.gateway.policySummaryDetails.Bundled',
        defaultMessage: 'Bundled'
    },
    contingencies: {
        id: 'ml.gateway.policySummaryDetails.Contingencies',
        defaultMessage: 'Contingencies'
    },
    groupName: {
        id: 'ml.gateway.policySummaryDetails.Group Name',
        defaultMessage: 'Group Name: {name}'
    },
    gpcCode: {
        id: 'ml.gateway.policySummaryDetails.GPC Code',
        defaultMessage: 'GPC Code: {code}'
    },
    paypointName: {
        id: 'ml.gateway.policySummaryDetails.Paypoint Name',
        defaultMessage: 'Paypoint Name: {name}'
    },
    paypointCode: {
        id: 'ml.gateway.policySummaryDetails.Paypoint Code',
        defaultMessage: 'Paypoint: {code}'
    },
    fullTermPremium: {
        id: 'ml.gateway.policySummaryDetails.Full Term Premium',
        defaultMessage: 'Full Term Premium:'
    },
    adjustedTermPremium: {
        id: 'ml.gateway.policySummaryDetails.Adjusted Term Premium',
        defaultMessage: 'Adjusted Term Premium:'
    },
    namedNonOwner: {
        id: 'ml.gateway.policySummaryDetails.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    },
    namedNonOwnerNP:{
        id: 'ml.gateway.policySummaryDetails.Named Non-OwnerNP',
        defaultMessage: 'Non Owner'
    },
    vehicle: {
        id: 'ml.gateway.policySummaryDetails.Vehicle',
        defaultMessage: '1 Vehicle'
    },
    vehicles: {
        id: 'ml.gateway.policySummaryDetails.Vehicles',
        defaultMessage: '{number} Vehicles'
    },
    excessLiability: {
        id: 'ml.gateway.policySummaryDetails.Excess Liability',
        defaultMessage: '{amount} Excess Liability'
    },
    serviceLevel: {
        id: 'ml.gateway.policySummaryDetails.Service Level',
        defaultMessage: "Service Level:"
    },
    docRetention: {
        id: 'ml.gateway.policySummaryDetails.DOC RETENTION',
        defaultMessage: "DOC RETENTION"
    },
    agentId: {
        id: 'ml.gateway.policySummaryDetails.Agent ID',
        defaultMessage: 'Agent ID: {agentId}'
    },
    view: {
        id: 'ml.gateway.policySummaryDetails.View',
        defaultMessage: 'View'
    },
    status: {
        id: 'ml.gateway.policySummaryDetails.Status',
        defaultMessage: 'Status:'
    },
    effectiveDate: {
        id: 'ml.gateway.policySummaryDetails.Effective Date',
        defaultMessage: 'Effective Date: {date}'
    },
    expirationDate: {
        id: 'ml.gateway.policySummaryDetails.Expiration Date',
        defaultMessage: 'Expiration Date: {date}'
    },
    yearTerm: {
        id: 'ml.gateway.policySummaryDetails.yearTerm',
        defaultMessage: '/year'
    },
    sixMonthsTerm: {
        id: 'ml.gateway.policySummaryDetails.sixMonthsTerm',
        defaultMessage: '/6 months'
    },
    sevenDayTerm: {
        id: 'ml.gateway.policySummaryDetails.sevenDayTerm',
        defaultMessage: '/7 days'
    },
    actionRequired: {
        id: 'ml.gateway.policySummaryDetails.actionRequired',
        defaultMessage: '({numberActionRequiredDocs}) Action required'
    }
});